import { IRequestWithPageSortFilterSearch } from 'redux/types';

export type TVatReimbursementState = {
	vatReimbursements: TVatReimbursementsData;
	vatReimbursementsLoading: boolean;
	receiveVatReimbursementLoading: boolean;
	updateCommentLoading: boolean;
};

export type TVatReimbursement = {
	id: number;
};

export enum VatReimbursementStatus {
	PAID = 'paid',
	PENDING = 'pending',
	NO_INVOICE = 'no_invoice',
	PARTIALLY_PAID = 'partially_paid',
}

export type TVatReimbursementsRequest = IRequestWithPageSortFilterSearch;

export type TVatReimbursementItem = {
	comments: string;
	countryCode: string;
	countryName: string;
	editedBy: string;
	emId: number;
	fiscalReportFilingDate: string;
	fullName: string;
	id: number;
	invoiceDate: string;
	invoiceId: number;
	invoiceNumber: string;
	invoicedBy: number;
	iossNumber: string;
	moneyReceived: boolean;
	paymentStatus: VatReimbursementStatus;
	receivedAt: string;
	reimbursementAmount: number;
	reportingPeriod: string;
	emStatus: string;
};
export type TVatReimbursementsResponse = {
	totalCount: number;
	pageSize: number;
	pageNumber: number;
	data: TVatReimbursementItem[];
};

export type TVatReimbursementsData = TVatReimbursementsResponse | null;

// ===============================================

export type TReceiveVatReimbursementRequest = {
	id: number;
	body: {
		text: string;
	};
	getVatReimbursementsRequest?: TVatReimbursementsRequest;
};

// ===============================================

export type TUpdateCommentRequest = {
	id: number;
	body: {
		text: string;
	};
	getVatReimbursementsRequest?: TVatReimbursementsRequest;
};

// ===============================================
